<template>
  <VContainer class="pa-0 add-processing">
    <VTabs v-model="tab" bg-color="backgroundPage" data-testid="portal-events-tabs" grow active-class="font-weight-medium" slider-color="transparent">
      <VTab data-testid="portal-events-updates-tab" value="updates" class="font14 portal-tab--split">
        {{ $t('header.module.updates') }}
      </VTab>
      <VTab data-testid="portal-events-calendar-tab" value="calendar" class="font14">
        {{ $t('header.module.calendar') }}
      </VTab>
    </VTabs>
    <VTabsWindow v-model="tab">
      <VTabsWindowItem data-testid="portal-events-updates-panel" value="updates">
        <VCard data-testid="portal-events-updates-card" color="backgroundDiv" variant="flat" class="py-6 px-md-0 px-lg-2 px-xl-6 pb-2 events">
          <UpdateList @click="emits('click')" />
        </VCard>
      </VTabsWindowItem>
      <VTabsWindowItem data-testid="portal-events-calendar-panel" value="calendar">
        <VCard data-testid="portal-events-calendar-card" color="backgroundDiv" variant="flat" class="px-4 py-3 events">
          <Calendar />
          <EventList />
        </VCard>
      </VTabsWindowItem>
    </VTabsWindow>
  </VContainer>
</template>
<script setup lang="ts">
import Calendar from '~/components/portal/events/Calendar.vue'
import EventList from '~/components/portal/events/EventList.vue'
import UpdateList from '~/components/portal/events/UpdateList.vue'

const tab = ref('updates')

const emits = defineEmits<{
  (e: 'click'): void
}>()
</script>

<style lang="scss" scoped>
@use '~/assets/scss/settings';
@use 'sass:map';

  .v-tab {
    background: transparent linear-gradient(0deg, #E3E3E3 0%, #F8F8F8 100%) 0% 0% no-repeat padding-box;
    color: rgba(0, 0, 0, 0.54);
    font-weight: 500;
    letter-spacing: .03em;
    text-decoration-color: rgba(0, 0, 0, 0.54);
  }
  .portal-tab--split {
    border-right: 1px solid rgb(var(--v-theme-border));
  }
  :deep(.v-tab--selected) {
    color: rgb(var(--v-theme-on-surface));
    font-weight: 600;
    text-decoration-line: underline;
    text-decoration-color: rgb(var(--v-theme-secondary));
    text-decoration-thickness: 3px;
    -webkit-text-decoration-line: underline;
    -webkit-text-decoration-color: rgb(var(--v-theme-secondary));
    -webkit-text-decoration-thickness: 3px;
    text-underline-position: under;
    text-underline-offset: 4px;
    box-shadow: inset 0px 3px 6px #00000012;
  }
  .events {
    overflow-x: hidden;
    overflow-y: auto;
    @media #{map.get(settings.$display-breakpoints, 'lg-and-up')}  {
      max-height: 740px;
    }
    @media #{map.get(settings.$display-breakpoints, 'md-and-down')}  {
      max-height: calc(100vh - 280px);
    }
  }
</style>
